import React from 'react';
import { Link } from 'react-router-dom';
import ellipseCircle from '../../assets/icons/ellipse-circle.svg';
import facebookIcon from '../../assets/icons/facebook-icon.svg';
import instagramIcon from '../../assets/icons/instagram-icon.svg';
import arrowRight from '../../assets/icons/arrow-right.svg';
import cloutLogo from '../../assets/logos/clout-logo.png';
import styles from './Footer.module.css';

interface FooterProps {
  onSignInClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onSignInClick }) => {
  return (
    <div className={styles.footerContainer} data-name="footer" id="node-12_9919">
      <div className={styles.footerContent} data-name="Footer Content" id="node-12_9920">
        <div className={styles.footerLayout}>
          <div className={styles.logoSection} data-name="Footer Logo Section">
            <img
              src={cloutLogo}
              alt="CLOUT - Healthcare Provider Review Platform"
              className={styles.logoImage}
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
            <div className={styles.socialIconsContainer}>
              <div
                className={styles.socialIconWrapper}
                data-name="Social Media Icon"
                onClick={onSignInClick}
              >
                <div className={styles.socialIconOuter}>
                  <img
                    alt=""
                    className={styles.socialIconImage}
                    loading="lazy"
                    src={ellipseCircle}
                  />
                </div>
                <div className={styles.socialIconInner} data-name="Facebook">
                  <div className={styles.facebookIconContainer} data-name="Icon">
                    <div className={styles.facebookIconInner}>
                      <img
                        alt=""
                        className={styles.socialIconImage}
                        loading="lazy"
                        src={facebookIcon}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={styles.socialIconWrapper}
                data-name="Social Media Icon"
                onClick={onSignInClick}
              >
                <div className={styles.socialIconOuter}>
                  <img
                    alt=""
                    className={styles.socialIconImage}
                    loading="lazy"
                    src={ellipseCircle}
                  />
                </div>
                <div className={styles.socialIconInner} data-name="Instagram">
                  <div className={styles.instagramIconContainer} data-name="Icon">
                    <div className={styles.instagramIconInner}>
                      <img
                        alt=""
                        className={styles.socialIconImage}
                        loading="lazy"
                        src={instagramIcon}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.footerLinks} data-name="Footer Links" id="node-12_9921">
            <div
              className={styles.footerLinkItem}
              data-name="Button Text"
              id="node-12_9922"
              onClick={onSignInClick}
            >
              <div className={styles.arrowIconWrapper} data-name="Iconly" id="node-12_9923">
                <div className={styles.arrowIconPositioner}>
                  <div className={styles.arrowIconRotator}>
                    <div
                      className={styles.arrowIconContainer}
                      data-name="Arrow - Right 2"
                      id="node-I12_9923-6_661-0_3756"
                    >
                      <div className={styles.arrowIconInner}>
                        <img
                          alt=""
                          className={styles.socialIconImage}
                          loading="lazy"
                          src={arrowRight}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.linkText} id="node-12_9924">
                <p className={styles.linkTextContent}>Find A Provider</p>
              </div>
            </div>
            <div
              className={styles.footerLinkItem}
              data-name="Button Text"
              id="node-12_9925"
              onClick={onSignInClick}
            >
              <div className={styles.arrowIconWrapper} data-name="Iconly" id="node-12_9926">
                <div className={styles.arrowIconPositioner}>
                  <div className={styles.arrowIconRotator}>
                    <div
                      className={styles.arrowIconContainer}
                      data-name="Arrow - Right 2"
                      id="node-I12_9926-6_661-0_3756"
                    >
                      <div className={styles.arrowIconInner}>
                        <img
                          alt=""
                          className={styles.socialIconImage}
                          loading="lazy"
                          src={arrowRight}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.linkText} id="node-12_9927">
                <p className={styles.linkTextContent}>Become CLOUT Certified</p>
              </div>
            </div>
            <Link
              to="/who-we-are"
              className={styles.footerLinkItem}
              data-name="Button Text"
              id="node-12_9928"
            >
              <div className={styles.arrowIconWrapper} data-name="Iconly" id="node-12_9929">
                <div className={styles.arrowIconPositioner}>
                  <div className={styles.arrowIconRotator}>
                    <div
                      className={styles.arrowIconContainer}
                      data-name="Arrow - Right 2"
                      id="node-I12_9929-6_661-0_3756"
                    >
                      <div className={styles.arrowIconInner}>
                        <img
                          alt=""
                          className={styles.socialIconImage}
                          loading="lazy"
                          src={arrowRight}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.linkText} id="node-12_9930">
                <p className={styles.linkTextContent}>Who We Are</p>
              </div>
            </Link>
            <div
              className={styles.footerLinkItem}
              data-name="Button Text"
              id="node-12_9931"
              onClick={onSignInClick}
            >
              <div className={styles.arrowIconWrapper} data-name="Iconly" id="node-12_9932">
                <div className={styles.arrowIconPositioner}>
                  <div className={styles.arrowIconRotator}>
                    <div
                      className={styles.arrowIconContainer}
                      data-name="Arrow - Right 2"
                      id="node-I12_9932-6_661-0_3756"
                    >
                      <div className={styles.arrowIconInner}>
                        <img
                          alt=""
                          className={styles.socialIconImage}
                          loading="lazy"
                          src={arrowRight}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.linkText} id="node-12_9933">
                <p className={styles.linkTextContent}>Endorse a Provider</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
